module.exports = __webpack_public_path__ + "static/0318-7a35833a52d310ba865f31af821aa87c.webp";